<div class="card">

  <div class="card-header compact">
    <h1>{{ 'common.labels.attachments' | translate }}</h1>
    <div class="card-actions">
      <app-button-group class="small">
        <button type="button"
          mat-stroked-button
          *ngIf="canUploadAttachments"
          data-id="create-button"
          (click)="createFile()"
          matTooltip="Launch the source code editor for a new text file attachment"
          class="compact fill-white">
          {{ 'common.actions.create' | translate }}
        </button>
        <button type="button"
          mat-stroked-button
          *ngIf="canUploadAttachments"
          data-id="upload-button"
          (click)="uploadAttachment()"
          matTooltip="Upload a file attachment from a local disk"
          class="compact fill-white">
          {{ 'common.actions.upload' | translate }}
        </button>
      </app-button-group>
    </div>
  </div>

  <ng-template #emptyState>
    <div class="blank-state">
      <mat-icon class="sm raised blue">attach_file</mat-icon>
      <p>{{ 'containerAttachments.labels.noAttachments' | translate }}</p>
    </div>
  </ng-template>

  <ng-container *ngIf="filteredAttachments$ | async as filteredAttachments">
    <div class="card-content">
      <table mat-table *ngIf="filteredAttachments.length > 0 || filtersActive; else emptyState" [dataSource]="filteredAttachments$" class="legacy-table small-form-field">
        <ng-container matColumnDef="name" [formGroup]="filterFields">
          <th mat-header-cell *matHeaderCellDef>
            <span class="filter-field">
              <mat-icon (click)="sort.changeSort('name')" class="sort-icon xs">{{ sort.getSortIcon('name') }}</mat-icon>
              <mat-form-field appearance="outline" class="full-width no-min-width solid-background">
                <mat-label>{{ 'common.labels.fileName' | translate }}</mat-label>
                <mat-icon matPrefix class="xs">filter_alt</mat-icon>
                <input type="text" matInput formControlName="name" autocomplete="off" test-id="container-attachment-name-filter">
              </mat-form-field>
            </span>
          </th>
          <td mat-cell *matCellDef="let file">
            <div>
              <span class="left-icons-wrapper">
                <mat-icon test-id="container-attachment-file-origin" *ngIf="getFileOrigin(file) as originInfo"
                  matTooltip="{{ originInfo.popoverText }}" class="file-origin xs blue">
                  {{ originInfo.matIcon }}
                </mat-icon>
                <mat-icon *ngIf="file.copy_of && features.copyByReference"
                  [matTooltip]="'common.labels.referenced' | translate | interpolate:file.copy_of.project_label"
                  class="xs blue">
                  link
                </mat-icon>
              </span>
              <fw-ellipsis [text]="file.name" test-id="container-attachment-file-name"></fw-ellipsis>
              <file-version-badge *ngIf="file.version > 1" test-id="container-attachment-file-version"
                [file]="file" (afterChange)="signalChange()" class="version-badge"></file-version-badge>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="created" [formGroup]="filterFields">
          <th mat-header-cell *matHeaderCellDef>
            <span class="filter-field">
              <mat-icon (click)="sort.changeSort('created')" class="sort-icon xs">{{ sort.getSortIcon('created') }}</mat-icon>
              <mat-form-field appearance="outline" class="full-width no-min-width solid-background">
                <mat-label>{{ 'common.labels.timestamp' | translate }}</mat-label>
                <mat-icon matPrefix class="xs">filter_alt</mat-icon>
                <input type="text" matInput formControlName="created" autocomplete="off"
                  test-id="container-attachment-timestamp-filter">
              </mat-form-field>
            </span>
          </th>
          <td mat-cell *matCellDef="let file">{{ file.created | date:'yyyy-MM-dd HH:mm' }}</td>
        </ng-container>

        <ng-container matColumnDef="classification" [formGroup]="filterFields">
          <th mat-header-cell *matHeaderCellDef>
            <span class="filter-field">
              <mat-icon (click)="sort.changeSort('classification')" class="sort-icon xs">{{ sort.getSortIcon('classification') }}</mat-icon>
              <mat-form-field appearance="outline" class="full-width no-min-width solid-background">
                <mat-label>{{ 'common.labels.classification' | translate }}</mat-label>
                <mat-icon matPrefix class="xs">filter_alt</mat-icon>
                <input type="text" matInput formControlName="classification" autocomplete="off"
                  test-id="container-attachment-classification-filter">
              </mat-form-field>
            </span>
          </th>
          <td mat-cell *matCellDef="let file">
            <fw-ellipsis [text]="getFileClassification(file)" test-id="container-attachment-file-classification"></fw-ellipsis>
          </td>
        </ng-container>

        <ng-container matColumnDef="type" [formGroup]="filterFields">
          <th mat-header-cell *matHeaderCellDef>
            <span class="filter-field">
              <mat-icon (click)="sort.changeSort('type')" class="sort-icon xs">{{ sort.getSortIcon('type') }}</mat-icon>
              <mat-form-field appearance="outline" class="full-width no-min-width solid-background">
                <mat-label>{{ 'common.labels.type' | translate }}</mat-label>
                <mat-icon matPrefix class="xs">filter_alt</mat-icon>
                <input type="text" matInput formControlName="type" autocomplete="off" test-id="container-attachment-type-filter">
              </mat-form-field>
            </span>
          </th>
          <td mat-cell *matCellDef="let file">{{ file.type }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'common.labels.actions' | translate }}</th>
          <td mat-cell *matCellDef="let file" class="text-right list-action-buttons">
            <file-actions
              *ngIf="!fileQuarantined(file)"
              [attr.data-id]="'attachment-options-menu'"
              [file]="file"
              [container]="container"
              (afterChange)="signalChange()"
              (afterDelete)="signalChange()"
              [kabobFeatures]="$any(['info', 'download', 'delete', 'version-history', 'view'])"
              [viewParams]="fileViewParameters$ | async"
              matTooltip="Actions"
              style="float:right">
              <mat-icon class="meatballs xs">more_vert</mat-icon>
            </file-actions>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="attachmentColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: attachmentColumns;" class="list-action-hover"></tr>
      </table>
    </div>
  </ng-container>
</div>
